import { h } from 'preact';
import * as BaseComp from 'components/bolt/socials/socials.js';
// import s from 'components/bolt/socials/socials.sss';

export default class Socials extends BaseComp.default {

	render(props) {
		const base = super.render(props);
		if (!base) return null;
		
		base.nodeName = 'ul';
		base.children = base.children.map(link => <li>{link}</li>);

		return base;
	}
	
}
